import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'small-card',
  templateUrl: './small-card.component.html',
  styleUrls: ['./small-card.component.scss'],
  standalone: false,
})
export class SmallCardComponent extends CardComponent implements OnInit {
  @Input() image;
  @Input() mode = 'potrait';
  @Input() tag: string;
  template = 'external';

  constructor(private router: Router) {
    super();
  }

  ngOnInit() {
    const to = this.to?.trim();
    if (to && to.search(/(http|https):/) !== 0) {
      this.template = 'internal';
      this.to = to.startsWith('/') ? to : `/${to}`;
    }
  }

  navigateInternal(event: MouseEvent) {
    const to = this.to?.trim();
    const isRouterUrl =
      !!to &&
      to.startsWith('/') &&
      !to.startsWith('//');

    if (
      isRouterUrl &&
      !event.defaultPrevented &&
      !event.ctrlKey &&
      !event.metaKey &&
      !event.shiftKey &&
      !event.altKey &&
      event.button === 0
    ) {
      event.preventDefault();
      this.router.navigateByUrl(to);
    }
  }
}